<template>
  <div
    class="row f-widget"
    v-if="is_visible"
    :class="{ 'has-state-condition': design && has_for_state }"
  >
    <div class="col-12">
      <component
        :is="field.field_type + '-widget'"
        :field="field"
        :fields="fields"
        :item="item"
        :design="design"
        @change="change(item)"
        @error="handleError"
        :form-state="formState"
        :form-context="formContext"
        :selector="selector"
        :disabled="disabled"
        :hide-label="inTable"
        horizontal
      />

      <b-alert show variant="warning" v-if="missing_widget"
        >Cannot find the Widget: {{ this.field.field_type }}
      </b-alert>

      <div class="action-buttons" v-if="active && !disabled">
        <o-list-actions :index="field_index" :list="fields" disable-delete>
        </o-list-actions>
      </div>
    </div>
  </div>
</template>

<script>
import TextWidget from "./text/TextWidget.vue";

import NumberWidget from "./number/NumberWidget.vue";
import MoneyWidget from "./money/MoneyWidget.vue";

import SectionWidget from "./section/SectionWidget.vue";
import ConditionalWidget from "./conditional/ConditionalWidget.vue";
import WizardWidget from "./wizard/WizardWidget.vue";
import WizardstepWidget from "./wizard/WizardStepWidget.vue";
import FormulaWidget from "./formula/FormulaWidget.vue";
import SelectWidget from "./select/SelectWidget.vue";
import MultiselectWidget from "./multiselect/MultiSelectWidget.vue";
import RepeatWidget from "./repeat/RepeatWidget.vue";
import TableWidget from "./table/TableWidget.vue";
import TextareaWidget from "./textarea/TextAreaWidget.vue";
import StatichtmlWidget from "./statichtml/StatichtmlWidget.vue";

import CheckboxWidget from "./checkbox/CheckboxWidget.vue";
import DatetimeWidget from "./datetime/DatetimeWidget.vue";
import FileuploadWidget from "./fileupload/FileuploadWidget.vue";
import { default as Checkbox_text_filesWidget } from "./yes_no_notes_files/YesNoNotesFilesWidget.vue";

import OListActions from "../../vue-ocom/components/table/OListActions.vue";

import { FIELD_TYPES_BY_CODE } from "../field_types.js";
import HamburgerIcon from "vue-material-design-icons/Hamburger.vue";
import { cloneDeep } from "lodash";

export default {
  name: "FWidget",
  components: {
    HamburgerIcon,
    OListActions,
    TextWidget,
    NumberWidget,
    MoneyWidget,
    SelectWidget,
    MultiselectWidget,
    TextareaWidget,
    CheckboxWidget,
    StatichtmlWidget,
    SectionWidget,
    RepeatWidget,
    TableWidget,
    ConditionalWidget,
    DatetimeWidget,
    FileuploadWidget,
    FormulaWidget,
    WizardWidget,
    WizardstepWidget,
    Checkbox_text_filesWidget,
  },
  model: {
    event: "change",
    prop: "item",
  },
  data: function () {
    return {};
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    field: {
      type: Object,
      default: () => {},
    },
    field_index: { type: Number, default: 0 },
    design: { type: Boolean, default: false },

    fields: { type: Array, default: () => [] },
    formState: {
      type: Object,
      default: () => {},
    },
    formContext: {
      type: Object,
      default: () => ({}),
    },
    selector: { type: Object, default: null },
    inTable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    handleError(msg) {
      this.$emit("error", msg);
    },
    edit_field() {
      if (this.selector) {
        this.selector.editThis(this.field, this.fields);
      }
    },
    change(item) {
      // Just propagate up
      console.log(`[${new Date().toISOString()}] FWidget @change event:`, {
        component: "FWidget",
        fieldCode: this.field.code,
        fieldType: this.field.field_type,
        item: item,
      });
      this.$emit("change", item);
    },
    fieldsChanged() {
      this.$emit("fields-change", this.fields);
    },
    duplicate() {
      var newField = cloneDeep(this.field);

      //TODO Make sure code is unique!

      newField.name = newField.name + "_copy";
      newField.code = newField.code + "_copy";

      this.fields.push(newField);
    },
  },
  computed: {
    is_visible() {
      // Always show in design mode
      if (this.design) {
        return true;
      }

      var result = true;
      // Check if widget should be visible based on for_state property
      if (this.field && this.field.for_state) {
        result = false; // we have a for_state so make default to false

        // If for_state has a value, check if it's true in formContext.states
        if (this.formContext && this.formContext.states) {
          // Split for_state by comma and check each state
          const states = this.field.for_state.split(",").map((s) => s.trim());
          result = states.some(
            (state) => !!this.formContext.states[state]
          );
        }
      }

      // If no for_state set, always show
      return result;
    },
    has_for_state() {
      // Check if this field has a for_state value set
      return (
        this.field && this.field.for_state && this.field.for_state.trim() !== ""
      );
    },
    missing_widget() {
      return FIELD_TYPES_BY_CODE[this.field.field_type] == null;
    },
    is_container() {
      return FIELD_TYPES_BY_CODE[this.field.field_type].container;
    },
    active() {
      if (this.design) {
        if (this.selector) {
          return this.selector.field === this.field;
        }
      }

      return false;
    },
  },
};
</script>

<style scoped>
.selected {
  border: silver 1px solid;
  background-color: rgba(140, 210, 255, 0.45);
}

.has-state-condition {
  border: 2px dashed rgba(147, 51, 234, 0.4) !important;
  border-radius: 4px;
  padding: 4px;
  margin: 2px 0;
}

.action-buttons {
  position: absolute;
  top: -38px;
  left: 0;
  z-index: 100;
}
</style>
